import React from 'react';

export default function GroupeSelogerLogo() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="178"
      height="43"
      fill="none"
      viewBox="0 0 178 43"
    >
      <g clipPath="url(#clip0_611_1823)">
        <path
          fill="#000"
          d="M18.772 30.366c0-4.196 2.384-6.827 5.931-6.827 1.815 0 2.956.843 3.67 1.587l-.551.623c-.694-.744-1.632-1.365-3.098-1.365-3.078 0-4.973 2.309-4.973 5.984s1.794 6.043 4.85 6.043c1.223 0 2.364-.36 3.017-1.004v-4.115h-3.22v-.784h4.117v5.242c-.836.884-2.22 1.507-3.974 1.507-3.464-.002-5.769-2.673-5.769-6.891zM33.856 23.78h3.853c2.67 0 4.404.963 4.404 3.494 0 2.108-1.325 3.334-3.446 3.595l3.71 6.145h-1.08l-3.65-6.083h-2.853v6.083h-.938V23.78zm3.609 6.385c2.363 0 3.69-.944 3.69-2.891 0-1.988-1.325-2.711-3.69-2.711h-2.67v5.602h2.67zM45.985 30.346c0-4.176 2.303-6.807 5.525-6.807 3.24 0 5.545 2.63 5.545 6.807 0 4.196-2.303 6.907-5.545 6.907-3.222.002-5.525-2.71-5.525-6.907zm10.07 0c0-3.655-1.813-5.964-4.545-5.964s-4.546 2.309-4.546 5.964c0 3.675 1.814 6.063 4.546 6.063 2.732.002 4.546-2.388 4.546-6.063zM61.987 31.933v-8.154h.938v8.054c0 3.514 1.672 4.578 3.568 4.578 1.936 0 3.67-1.064 3.67-4.578v-8.054h.876v8.154c0 4.136-2.221 5.322-4.546 5.322-2.305 0-4.506-1.186-4.506-5.322zM76.848 23.78h3.384c3.037 0 4.872.963 4.872 3.694 0 2.591-1.794 3.856-4.79 3.856h-2.528v5.683h-.938V23.779zm3.24 6.766c2.732 0 4.056-.904 4.056-3.072 0-2.228-1.365-2.911-4.137-2.911h-2.222v5.983h2.303zM89.935 23.78h7.36v.803h-6.422v5h5.382v.803h-5.382v5.823h6.625v.803h-7.563V23.78zM124.658 32.202c-.059.334-.238.5-.535.5h-6.759l-.008.043a3.342 3.342 0 00-.045.848c.023.276.098.516.232.723.132.206.326.373.58.497.252.124.592.186 1.017.186.338 0 .7-.006 1.084-.02l1.141-.042c.376-.014.729-.03 1.058-.052.33-.02.6-.046.818-.074h.063c.268 0 .382.112.343.334l-.284 1.6a.814.814 0 01-.153.378c-.071.085-.203.149-.395.189a19.52 19.52 0 01-2.06.378 19.23 19.23 0 01-2.374.127c-.636 0-1.255-.09-1.859-.27a3.738 3.738 0 01-1.556-.899c-.435-.416-.747-.971-.936-1.659-.189-.69-.193-1.535-.016-2.537l.258-1.46a7.687 7.687 0 01.765-2.275c.36-.681.814-1.26 1.357-1.733a5.878 5.878 0 011.879-1.096c.71-.259 1.489-.387 2.338-.387.86 0 1.596.14 2.203.419.607.278 1.086.661 1.437 1.148.352.487.578 1.064.678 1.733.099.67.079 1.399-.061 2.193l-.21 1.208zm-3.051-1.67c.139-.779.072-1.36-.199-1.743-.271-.382-.704-.573-1.296-.573-.594 0-1.102.195-1.523.585-.423.39-.702.968-.836 1.734l-.017.084h3.857l.014-.086zM145.845 32.39a7.697 7.697 0 01-.751 2.254 5.91 5.91 0 01-1.322 1.701 5.725 5.725 0 01-1.849 1.086c-.704.257-1.489.387-2.351.387-.863 0-1.601-.128-2.213-.387-.612-.256-1.105-.619-1.475-1.086-.37-.467-.612-1.034-.728-1.701-.116-.667-.098-1.419.049-2.254l.258-1.461a7.725 7.725 0 01.75-2.255 5.797 5.797 0 011.333-1.7 5.897 5.897 0 011.859-1.087c.704-.258 1.487-.387 2.351-.387.865 0 1.603.129 2.216.387.612.259 1.1.62 1.464 1.086.364.467.602 1.034.716 1.701.116.668.099 1.42-.049 2.255l-.258 1.46zm-3.173-1.461c.301-1.7-.173-2.547-1.424-2.547-.619 0-1.127.212-1.526.637-.398.425-.673 1.062-.823 1.91l-.261 1.46c-.15.85-.101 1.49.145 1.922.246.431.679.648 1.297.648 1.251 0 2.028-.858 2.331-2.57l.261-1.46zM158.399 27.4c-.026.152-.077.259-.151.313a1.015 1.015 0 01-.311.146l-.693.21c.091.195.158.44.199.732.04.292.036.563-.006.813l-.031.167c-.242 1.364-.875 2.356-1.896 2.975-1.021.62-2.365.93-4.031.93-.494 0-.928-.032-1.298-.094a4.04 4.04 0 01-.85-.218.847.847 0 00-.272.218.582.582 0 00-.11.26c-.031.167-.01.293.061.377.069.084.225.152.472.209l2.302.523c.883.194 1.627.386 2.229.573.603.188 1.076.402 1.422.647.346.244.572.535.682.878.109.34.12.761.03 1.262l-.03.166c-.403 2.269-2.456 3.403-6.158 3.403-1.765 0-3.053-.293-3.86-.878-.807-.585-1.113-1.426-.917-2.527l.03-.166c.077-.43.248-.842.515-1.232.266-.39.657-.758 1.172-1.107a1.437 1.437 0 01-.672-.865 2.37 2.37 0 01-.065-1.076c.069-.389.218-.732.447-1.024.229-.293.497-.543.802-.752-.287-.292-.466-.675-.537-1.148a4.098 4.098 0 01.004-1.336l.028-.167c.21-1.182.8-2.136 1.768-2.86.97-.723 2.38-1.085 4.231-1.085h5.276c.155 0 .275.052.354.156a.469.469 0 01.079.387l-.215 1.19zm-5.754 10.919a.511.511 0 00-.025-.283c-.035-.09-.12-.178-.26-.26a2.98 2.98 0 00-.612-.25c-.269-.085-.633-.18-1.093-.293l-1.509-.335a3.332 3.332 0 00-.409.575c-.114.203-.203.483-.267.846l-.03.166c-.063.363.037.63.303.804.267.172.808.26 1.63.26.437 0 .795-.024 1.071-.074.277-.048.499-.122.664-.218a.934.934 0 00.357-.345 1.32 1.32 0 00.151-.429l.029-.164zm1.44-8.707c.077-.43.014-.79-.189-1.074-.204-.286-.68-.429-1.428-.429-.749 0-1.284.143-1.601.43-.32.284-.517.642-.594 1.073l-.028.167a1.882 1.882 0 00-.021.533c.018.174.085.33.201.468.116.14.291.251.525.335.232.082.553.124.962.124.749 0 1.276-.132 1.577-.396.301-.265.49-.62.571-1.064l.025-.167zM168.14 32.201c-.059.335-.238.501-.533.501h-6.761l-.008.042a3.342 3.342 0 00-.045.848c.022.276.1.517.232.723.132.207.325.373.58.497.252.125.592.187 1.017.187.337 0 .7-.006 1.084-.02l1.141-.042c.376-.014.73-.03 1.058-.053.329-.02.599-.046.817-.074h.063c.269 0 .383.112.344.335l-.284 1.599a.813.813 0 01-.153.379c-.072.084-.204.148-.395.188-.708.168-1.393.295-2.058.379-.666.084-1.457.126-2.374.126-.637 0-1.255-.09-1.859-.27a3.738 3.738 0 01-1.556-.898c-.433-.417-.746-.972-.934-1.66-.189-.689-.193-1.534-.016-2.536l.258-1.461a7.687 7.687 0 01.765-2.274c.36-.682.814-1.26 1.357-1.734a5.878 5.878 0 011.879-1.096c.71-.258 1.489-.387 2.335-.387.863 0 1.597.14 2.205.42.608.278 1.086.66 1.438 1.147.352.487.578 1.064.678 1.734.099.669.081 1.398-.059 2.192l-.216 1.208zm-3.051-1.669c.138-.78.071-1.36-.199-1.743-.271-.383-.704-.573-1.298-.573-.594 0-1.1.194-1.523.585-.421.389-.702.968-.836 1.733l-.015.084h3.857l.014-.086zM176.125 28.192a.324.324 0 01-.256.126h-.169c-.523 0-1.023.07-1.499.208a8.77 8.77 0 00-1.365.521l-1.446 8.144a.527.527 0 01-.181.302.476.476 0 01-.321.137h-2.565a.353.353 0 01-.283-.137.349.349 0 01-.083-.302l1.97-11.108a.495.495 0 01.18-.292.484.484 0 01.319-.126h2.522c.114 0 .206.042.275.126a.348.348 0 01.075.294l-.075.421a5.425 5.425 0 011.478-.745 4.953 4.953 0 011.562-.263c.112 0 .204.042.275.127a.339.339 0 01.075.294l-.354 1.998a.579.579 0 01-.134.274zM133.854 37.54a7.797 7.797 0 01-.683.116 19.18 19.18 0 01-1.141.118c-.326.024-.81.036-1.093.036a10.81 10.81 0 01-1.93-.166c-.609-.11-1.121-.327-1.536-.648-.415-.32-.712-.775-.887-1.368-.177-.591-.179-1.36-.008-2.307l1.949-10.794a.493.493 0 01.179-.293.483.483 0 01.319-.126h2.776a.34.34 0 01.275.126c.071.084.096.18.075.293l-1.946 10.794c-.098.543-.063.916.106 1.117.168.202.5.302.994.302h3.06a.347.347 0 01.347.417l-.35 1.942c-.046.238-.213.384-.506.44zM114.278 23.853a19.37 19.37 0 00-1.914-.41c-.657-.107-1.493-.16-2.483-.16-1.715 0-3.057.32-3.989.955-.919.625-1.495 1.557-1.715 2.765-.138.774-.075 1.463.192 2.048.266.585.707 1.074 1.309 1.453l2.992 1.896c.354.22.586.42.716.61a.913.913 0 01.149.69c-.072.397-.248.7-.525.894-.27.192-.728.284-1.401.284a29.912 29.912 0 01-1.977-.102 58.625 58.625 0 01-1.229-.114 20.66 20.66 0 01-1.108-.138h-.086a.312.312 0 00-.224.078.368.368 0 00-.116.208l-.37 2.046c-.033.183.02.263.21.313.299.082.638.156 1.013.222a22.287 22.287 0 002.363.287c.391.024.765.038 1.117.038.909 0 1.723-.106 2.418-.319.694-.21 1.296-.499 1.792-.861.493-.36.893-.79 1.192-1.283a4.673 4.673 0 00.68-2.553 2.482 2.482 0 00-.2-.914 3.22 3.22 0 00-.58-.893c-.26-.293-.624-.59-1.077-.88l-2.86-1.795a2.969 2.969 0 01-.56-.455.753.753 0 01-.176-.664c.081-.454.343-.66.546-.753.257-.116.643-.172 1.178-.172.328 0 .706.012 1.123.038.409.024.82.054 1.22.088.399.034.769.072 1.105.114.325.042.581.07.761.086h.065c.12 0 .24-.022.289-.286l.37-2.046c.035-.183-.019-.263-.21-.315z"
        />
        <path
          fill="url(#paint0_linear_611_1823)"
          d="M2.898 35.353v-24.52L.948 9.95v27.325l1.95-1.922z"
        />
        <path
          fill="url(#paint1_linear_611_1823)"
          d="M12.65 12.277l1.95-1.44V.603l-.044.037-1.906 4.067v7.569z"
        />
        <path
          fill="url(#paint2_linear_611_1823)"
          d="M12.65 35.353H2.898l-1.95 1.922h13.63l-1.928-1.976v.054z"
        />
        <path
          fill="url(#paint3_linear_611_1823)"
          d="M2.898 10.81l9.752-6.124v.024L14.555.642.949 9.904v.048l1.95.881v-.024z"
        />
        <path
          fill="url(#paint4_linear_611_1823)"
          d="M29.717 14.698l-8.27-6.519-.035.026v2.409l6.336 4.993 1.97-.863v-.046z"
        />
        <path
          fill="url(#paint5_linear_611_1823)"
          d="M27.748 15.607l.019.014v4.86h1.95v-5.737l-1.968.863z"
        />
        <path
          fill="url(#paint6_linear_611_1823)"
          d="M12.65 14.678v.018l1.97.93 6.788-5.016.004.004V8.205l-8.762 6.473z"
        />
        <path
          fill="url(#paint7_linear_611_1823)"
          d="M12.65 35.3l1.928 1.975h.022V15.639l.02-.014-1.97-.93V35.3z"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_611_1823"
          x1="1.923"
          x2="1.923"
          y1="37.275"
          y2="9.951"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.093" stopColor="#A61B34" />
          <stop offset="0.166" stopColor="#B1192A" />
          <stop offset="0.298" stopColor="#BC171F" />
          <stop offset="0.484" stopColor="#C31619" />
          <stop offset="1" stopColor="#C51617" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_611_1823"
          x1="13.626"
          x2="13.626"
          y1="12.277"
          y2="0.604"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E63635" />
          <stop offset="0.196" stopColor="#E13231" />
          <stop offset="0.423" stopColor="#D32827" />
          <stop offset="0.646" stopColor="#BE1818" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_611_1823"
          x1="0.948"
          x2="14.578"
          y1="36.287"
          y2="36.287"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.147" stopColor="#A61B34" />
          <stop offset="0.61" stopColor="#64247E" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_611_1823"
          x1="1.611"
          x2="15.048"
          y1="10.886"
          y2="1.335"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C61617" />
          <stop offset="0.823" stopColor="#BE1818" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_611_1823"
          x1="20.963"
          x2="28.876"
          y1="8.714"
          y2="15.697"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00749C" />
          <stop offset="0.279" stopColor="#0580AF" />
          <stop offset="0.919" stopColor="#119AD7" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_611_1823"
          x1="28.732"
          x2="28.732"
          y1="20.733"
          y2="14.997"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0086CD" />
          <stop offset="0.904" stopColor="#119AD7" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_611_1823"
          x1="13.089"
          x2="21.976"
          y1="15.313"
          y2="8.997"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00749C" />
          <stop offset="0.62" stopColor="#0077A1" />
          <stop offset="1" stopColor="#007BA7" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_611_1823"
          x1="13.635"
          x2="13.635"
          y1="37.275"
          y2="14.696"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#66247A" />
          <stop offset="0.564" stopColor="#2C548F" />
          <stop offset="1" stopColor="#04759D" />
        </linearGradient>
        <clipPath id="clip0_611_1823">
          <path
            fill="#fff"
            d="M0 0H176.105V41.709H0z"
            transform="translate(.948 .604)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
